<template>
    <layout-theme>
        <layout-header />

        <div class="container mt-5">
            <div class="column is-12 is-centered survey-box">
                
                <b-field
                    label="Nome Completo"
                    :type="{ 'is-danger': !!errors['person.full_name'] }"
                    :message="errors['person.full_name']"
                    custom-class="required"
                >
                    <b-input v-model="user.person.full_name" />
                </b-field>

                <b-field
                    label="Nome Social"
                    :type="{ 'is-danger': !!errors['person.social_name'] }"
                    :message="errors['person.social_name']"
                >
                    <b-input v-model="user.person.social_name" @input="showSocialNameInfo=true" @blur="showSocialNameInfo=false"/>
                    <b-message has-icon type="is-warning" v-if="showSocialNameInfo">
                        <strong>Nome Social</strong> é o nome pelo qual pessoas transgênero e travestis
                        preferem ser chamadas, em vez de seus nomes de registro, para
                        respeitar e reconhecer sua identidade de gênero autodeclarada.
                        É uma forma de promover inclusão e respeito às suas identidades.
                    </b-message>
                </b-field>


                <b-field
                    label="CPF"
                    :type="{ 'is-danger': !!errors['person.cpf_number'] }"
                    :message="errors['person.cpf_number']"
                >
                    <b-input v-model="user.person.cpf_number" v-cleave="$cleave.masks.cpf"  />
                </b-field>

                <b-field
                    label="Telefone"
                    :type="{ 'is-danger': !!errors['person.phone'] }"
                    :message="errors['person.phone']"
                >
                    <b-input v-model="user.person.phone" v-cleave="$cleave.masks.phone" />
                </b-field>

                <b-field
                    label="Celular"
                    :type="{ 'is-danger': !!errors['person.cell_phone'] }"
                    :message="errors['person.cell_phone']"
                >
                    <b-input v-model="user.person.cell_phone" v-cleave="$cleave.masks.phone" />
                </b-field>

                <b-field
                    label="E-mail"
                    :type="{ 'is-danger': !!errors['person.email'] }"
                    :message="errors['person.email']"
                >
                    <b-input v-model="user.person.email" />
                </b-field>

                <b-field
                    label="Data de Nascimento"
                    :type="{ 'is-danger': !!errors['person.birthdate'] }"
                    :message="errors['person.birthdate']"
                >
                    <b-datepicker
                        v-model="user.person.birthdate"
                        locale="pt-BR"
                        icon="calendar"
                        trap-focus
                        editable
                        v-cleave="$cleave.masks.date"
                    />
                </b-field>

                <b-field
                    label="Gênero"
                    :type="{ 'is-danger': !!errors['person.gender'] }"
                    :message="errors['person.gender']"
                >
                    <b-select ref="gender" v-model="user.person.gender">
                        <option v-for="option in genderOptions" :value="option.id" :key="option.id">
                            {{ option.name }}
                        </option>
                    </b-select>
                </b-field>

                <b-field class="pt-5">
                    <b-button
                        :disabled="userUpdating"
                        icon-left="save"
                        label="Salvar"
                        type="is-success"
                        @click="save"
                    />
                </b-field>
                
            </div>

        </div>
    </layout-theme>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapGetters } from 'vuex'
import api from '@/api.js'
import '@/cleave.js'
import LayoutTheme from '@/components/LayoutTheme.vue'
import LayoutHeader from '@/components/LayoutHeader.vue'

const NEXT = '/survey'

export default {
    name: 'Update',

    components: {
        LayoutTheme,
        LayoutHeader,
    },

    beforeRouteEnter (to, from, next) {
        next(vm => {
            if (vm.user) {
                if (!vm.updateRequired(vm.user)) {
                    vm.$router.push(NEXT)
                }
            } else {
                vm.$router.push({ name: 'SignOut' })
            }
        })
    },

    data() {
        return {
            showSocialNameInfo: false,
            user: {},
            userUpdating: false,
            errors: {
                person: {},
            },
            genderOptions: [
                { id: 'F', name: 'Feminino'},
                { id: 'M', name: 'Masculino'},
                { id: 'O', name: 'Outro'},
                { id: 'N', name: 'Prefiro não dizer'},
            ],
        }
    },

    created() {
        this.user = _.cloneDeep(this.userStore)

        if (this.user.person.birthdate) {
            this.user.person.birthdate = moment(this.user.person.birthdate, 'YYYY-MM-DD').toDate()
        }
    },

    methods: {
        updateRequired(user) {
            if (moment().diff(moment(user.person.updated_at, 'YYYY-MM-DD HH:mm:ss'), 'days') > 30) {
                console.log('Atualização necessária pois há mais de 30 dias que o usuário não atualiza seu cadastro')
                return true
            }

            if (!user.person.birthdate) {
                this.$buefy.toast.open({
                    message: 'Informe sua data de nascimento',
                    type: 'is-warning',
                    position: 'is-bottom',
                    duration: 6000,
                })
                console.log('Atualização necessário pois o usuário não possui data de nascimento informada')
                return true
            }

            if (!user.person.email) {
                this.$buefy.toast.open({
                    message: 'Informe seu endereço de e-mail',
                    type: 'is-warning',
                    position: 'is-bottom',
                    duration: 6000,
                })
                console.log('Atualização necessário pois o usuário não possui endereço de e-mail informado')
                return true
            }

            if (!user.person.gender) {
                this.$buefy.toast.open({
                    message: 'Informe o seu gênero',
                    type: 'is-warning',
                    position: 'is-bottom',
                    duration: 6000,
                })
                console.log('Atualização necessário pois o usuário não possui gênero informado')
                return true
            }

            if (!user.person.phone && !user.cell_phone) {
                this.$buefy.toast.open({
                    message: 'Informe um número de telefone ou celular',
                    type: 'is-warning',
                    position: 'is-bottom',
                    duration: 6000,
                })
                console.log('Atualização necessário pois o usuário não possui nenhum telefone ou celular informado')
                return true
            }

            console.log('Não é necessário atualizar o cadastro.')
            return false
        },

        save() {
            const user = {
                person: {
                    full_name: this.user.person.full_name,
                    social_name: this.user.person.social_name,
                    email: this.user.person.email,
                    gender: this.user.person.gender,
                    phone: this.user.person.phone,
                    cell_phone: this.user.person.cell_phone,
                }
            }

            if (this.user.person.birthdate) {
                user.person.birthdate = moment(this.user.person.birthdate).format('YYYY-MM-DD')
            }

            if (this.user.person.cpf_number) {
                user.person.cpf_number = this.user.person.cpf_number.replace(/[.-]/g, "")
            }

            if (!this.user.person.phone) {
                delete user.person.phone
            }

            if (!this.user.person.cell_phone) {
                delete user.person.cell_phone
            }

            const loading = this.$buefy.loading.open()
            this.userUpdating = true

            api.userRequest({
                url: `user/me`,
                method: 'put',
                data: user
            }).then(data => {
                this.$store.commit('setUser', data.user)
                this.errors = {}
                this.$router.push(NEXT)
            }).catch(e => {
                let message = e.message

                if (e.response && e.response.data) {
                    const data = e.response.data

                    if (data.exception && data.exception.type) {
                        switch (data.exception.type) {
                            case 'ValidationException':
                                if (data.exception.details) {
                                    message = Object.values(data.exception.details)[0][0]
                                    this.errors = data.exception.details
                                } else {
                                    message = data.exception.message ? data.exception.message : data.exception.type
                                }
                                break

                            default:
                                message = data.exception.message ? data.exception.message : data.exception.type
                                break;
                        }
                    }
                }

                this.$buefy.toast.open({
                    duration: 3500,
                    message: message,
                    position: 'is-bottom',
                    type: 'is-danger'
                })
            }).finally(() => {
                this.userUpdating = false
                loading.close()
            })
        },
    },

    computed: {
        ...mapGetters({
            userStore: 'getUser',
        })
    }
}
</script>
